export default "<ul class=\"vm-validation-error-list\">\n    <li ng-repeat=\"i in $ctrl._items\"><a href=\"#\" class=\"list-group-item\">{{i}}</a></li>\n</ul>"